import _ from 'lodash'

const isNotNil = val => !_.isNil(val)

export const hideProngNumber = ({shapes, prong_style}) => {
  return shapes[0] !== 'round' || prong_style === 'bezel' || prong_style === 'v_bracket'
}

export const hideBasketStyle = ({jewelry_type, has_central_halo, prong_style}) => {
  if (jewelry_type === 'EngagementRing') {
    return has_central_halo || prong_style === 'bezel'
  }
  return true
}

export const hideCathedralShoulders = ({jewelry_type}) => {
  return jewelry_type !== 'EngagementRing'
}

export const hideMultiStoneHaloMilgrain = ({side_stone_halo_setting_style}) => {
  return side_stone_halo_setting_style === null ||
         side_stone_halo_setting_style === 'pave' ||
         side_stone_halo_setting_style === 'shared_claw_set'
}

export const hideShankTopDiamondMilgrain = ({setting_style_of_diamonds_down_top_of_shank}) => {
  return setting_style_of_diamonds_down_top_of_shank === null ||
         setting_style_of_diamonds_down_top_of_shank === 'pave' ||
         setting_style_of_diamonds_down_top_of_shank === 'shared_claw_set'
}

export const hideCentralHaloMilgrain = ({central_halo_setting_style}) => {
  return central_halo_setting_style === null ||
         central_halo_setting_style === 'pave' ||
         central_halo_setting_style === 'shared_claw_set'
}

export const showHaloSideDiamondPanel = ({jewelry_type, has_central_halo, has_side_stone_halo}) => {
  return (jewelry_type === 'EngagementRing' && has_central_halo && !has_side_stone_halo) ||
           ((jewelry_type === 'Pendant' || jewelry_type === 'StudEarring') && has_central_halo)
}

export const showPrimaryDiamondPanel = ({jewelry_type}) => {
  return jewelry_type === 'EngagementRing' || jewelry_type === 'Pendant' || jewelry_type === 'StudEarring'
}

export const showMultiStonePanel = ({jewelry_type}) => {
  return jewelryTypeIsRing({jewelry_type}) && jewelry_type !== 'MaleWeddingBand'
}

export const showBailPanel = ({jewelry_type, basket_type}) => {
  return jewelry_type === 'Pendant' && basket_type === 'custom'
}

export const showBailDiamondPanel = ({jewelry_type, basket_type, has_bail}) => {
  return showBailPanel({jewelry_type, basket_type}) && has_bail
}

export const showPendantChainPanel = ({jewelry_type}) => {
  return jewelry_type === 'Pendant'
}

export const showMultiStoneHaloPanel = ({multi_stone_ring, diamonds_on_outside_of_halo}) => {
  return multi_stone_ring && !diamonds_on_outside_of_halo
}

export const showPrimaryDiamondHaloPanel = ({jewelry_type, basket_type}) => {
  return jewelry_type === 'EngagementRing' ||
         ((jewelry_type === 'StudEarring' || jewelry_type === 'Pendant') && basket_type === 'custom')
}

export const showProngPanel = ({jewelry_type, basket_type}) => {
  return jewelry_type === 'EngagementRing' ||
         ((jewelry_type === 'StudEarring' || jewelry_type === 'Pendant') && basket_type === 'custom')
}

export const showStockItemPanel = ({jewelry_type}) => {
  return jewelry_type === 'StockItem'
}

export const jewelryTypeIsRing = ({jewelry_type}) => {
  return jewelry_type === 'EngagementRing' ||
         jewelry_type === 'MaleWeddingBand' ||
         jewelry_type === 'FemaleWeddingBand'
}

export const showPrimaryMetalType = ({jewelry_type}) => {
  return isNotNil(jewelry_type) && jewelry_type !== 'StockItem'
}

export const hideBailDiamondMilgrain = ({bail_diamond_setting_style}) => {
  return bail_diamond_setting_style === null ||
          bail_diamond_setting_style === 'pave' ||
          bail_diamond_setting_style === 'shared_claw_set'
}

export const showAdditionalOptionPanel = ({jewelry_type, basket_type}) => {
  return isNotNil(jewelry_type) && !((jewelry_type === 'Pendant' || jewelry_type === 'StudEarring') && !(basket_type === 'custom')) && jewelry_type !== 'StockItem'
}

export const showBasketTypePanel = ({jewelry_type}) => {
  return jewelry_type === 'Pendant' || jewelry_type === 'StudEarring'
}

export const showAdditionalDiamondPanel = ({jewelry_type, basket_type}) => {
  return isNotNil(jewelry_type) && !((jewelry_type === 'Pendant' || jewelry_type === 'StudEarring') && !(basket_type === 'custom'))
}

export const showPrimaryMetalTypePanel = ({jewelry_type}) => {
  return jewelry_type === 'EngagementRing' ||
         jewelry_type === 'MaleWeddingBand' ||
         jewelry_type === 'FemaleWeddingBand' ||
         jewelry_type === 'Pendant' ||
         jewelry_type === 'StudEarring'
}

export const showAdditionalChargePanel = ({jewelry_type}) => {
  return isNotNil(jewelry_type)
}



// WEBPACK FOOTER //
// ./src/utils/jewelry-validation.js